export default __webpack_public_path__ + "static/media/ReFSocial1.9965aabb.svg";